import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import Skeleton from 'components/Skeleton';
import useDevice from 'hooks/useDeviceType';
import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import { withColorScheme } from 'redesignedComponents/decorators/withColorScheme';

import useStyles, { useItemStyles } from './styles';
import testIds from './testIds';

const ValueItemisationSkeleton = () => {
  const colorScheme = useColorScheme();
  const styles = useStyles({ colorScheme });
  const valueItemStyles = useItemStyles({ hasCta: true });
  const { isTablet, isMobile } = useDevice();

  const ValueItemSkeleton = () => {
    return (
      <div className={valueItemStyles.skeletonValueItemRoot}>
        <Skeleton className={valueItemStyles.skeletonImage} />
        <Skeleton className={valueItemStyles.skeletonText} />
        <Skeleton className={valueItemStyles.skeletonText} />
      </div>
    );
  };

  return (
    <div data-testid={testIds.valueItemisationSkeleton} className={styles.skeletonRoot}>
      <HorizontalContainer>
        <div className={styles.skeletonItems}>
          <ValueItemSkeleton />
          {!isTablet && !isMobile && (
            <>
              <ValueItemSkeleton />
              <ValueItemSkeleton />
            </>
          )}
        </div>
      </HorizontalContainer>
    </div>
  );
};

export default withColorScheme<unknown>(ValueItemisationSkeleton);
